import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles((theme) => {
  const styles: StyleRules = {
    buttonbase: {
      boxSizing: 'border-box',
      padding: `${theme.spacing(4)}px ${theme.spacing(2) * 3}px`,
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      cursor: 'pointer',
      width: `calc(50% - ${theme.spacing(1) * 2}px)`,
      margin: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      '&:hover': {
        border: `1px solid ${theme.palette.grey[500]}`,
        backgroundColor: theme.palette.grey[50],
        transition: 'border-color, background-color, 0.5s',
      },
      '& > img': {
        width: 'auto',
      },
      '&.registered': {
        position: 'relative',
        '&:after': {
          content: '"check_circle"',
          position: 'absolute',
          top: 4,
          right: 4,
          color: variables.palette.secondary.main,
          fontFamily: 'Material Icons',
          fontSize: 18,
        },
      },
    },
    buttonGroup: {
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        flexDirection: 'column',
      },
    },
    brandImg: {
      height: 35,
    },
    expand: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: 16,
    },
    table: {
      width: '100%',
    },
    tableBody: {
      overflowX: 'auto',
    },
    formControl: {
      '& > label': {
        fontWeight: 500,
      },
    },
    deleteButton: {
      position: 'absolute',
      right: 8,
      bottom: 8,
      zIndex: 3,
      color: 'black',
    },
    customMessage: {
      fontSize: '0.8rem',
      color: '#596375',
      marginBottom: 9,
    },
  };

  return styles;
});
